import cn from 'classnames'
import { isEmpty } from 'lodash'
import { Fragment, useMemo } from 'react'

import { FeedbackPostCommentFragment } from '~generated/operations'
import Box from '~lib/ui-kit/Box'
import FeedbackCommentCard from '~modules/feedbackTool/containers/FeedbackPostComment'
import { ReplyToOptions } from '~modules/feedbackTool/utils'
import Divider from '~shared/ui/Divider'

interface FeedbackCommentsListProps {
  comments: FeedbackPostCommentFragment[]
  replyingTo: ReplyToOptions
  onSetReplyingTo: (v: ReplyToOptions) => void
  className?: string
  disabled?: boolean
}

function FeedbackCommentsList({
  comments,
  replyingTo,
  onSetReplyingTo,
  className,
  disabled,
}: FeedbackCommentsListProps) {
  const commentsWithReplies = useMemo(() => {
    return comments?.reduce((acc, comment) => {
      if (!acc[comment.replyTo]) acc[comment.replyTo] = [comment]
      else acc[comment.replyTo] = [...acc[comment.replyTo], comment]
      return acc
    }, {} as Record<string, FeedbackPostCommentFragment[]>)
  }, [comments])

  const rootComments = useMemo(() => {
    return comments?.filter((comment) => !comment.replyTo)
  }, [comments])

  return (
    <Box className={cn('py-2 px-3', className)}>
      {!isEmpty(rootComments) && (
        <>
          {rootComments.map((comment, index, arr) => (
            <Fragment key={comment?.id}>
              <FeedbackCommentCard
                comment={comment}
                replies={comment?.id ? commentsWithReplies?.[comment.id] : []}
                replyingTo={replyingTo}
                onSetReplyingTo={onSetReplyingTo}
                disabled={disabled}
              />

              {index !== arr.length - 1 && <Divider direction="horizontal" className="mt-3 mb-3" />}
            </Fragment>
          ))}
        </>
      )}
    </Box>
  )
}

export default FeedbackCommentsList
